function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Math, Object, String, getFilterSortedMenuSections, searchText) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['simple-action'] = function({
      actionOption
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "key": JSON.stringify(actionOption),
          "attrs": __vjadeStringifyAttrsIfObj({
            theme: $attr(`action-button-theme`) || `tertiary`,
            role: `button`,
            tabindex: 0,
            disabled: actionOption.disabled,
            elref: actionOption.eventName,
            type: actionOption.type,
            icon: actionOption.icon,
            href: actionOption.href,
            target: actionOption.target,
          }),
          "on": {
            click: actionOption.disabled ? null : () => $helpers.handleClickAction(actionOption.eventName),
          },
          "class": {
            'action': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(actionOption.label);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        const toolTipMaxWidthStyle = actionOption.toolTipMaxWidthStyle ? actionOption.toolTipMaxWidthStyle : `150px`;
        __jade_nodes = __jade_nodes.concat((actionOption.disabledTooltip && actionOption.disabled) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj({
              placement: `bottom`,
              'max-width': toolTipMaxWidthStyle
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (actionOption.disabledTooltip) + "");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : (actionOption.tooltip) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj({
              placement: `bottom`,
              'max-width': toolTipMaxWidthStyle
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (actionOption.tooltip) + "");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['multiple-action'] = function({
      actionOption
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "key": JSON.stringify(actionOption),
          "attrs": __vjadeStringifyAttrsIfObj({
            icon: JSON.stringify({
              leftIcon: actionOption.icon
            }),
            'selected-option': actionOption.label,
            sections: actionOption.sections,
            'menu-width': actionOption.menuWidth || 200,
            'menu-height': actionOption.menuHeight || 300,
            elref: actionOption.eventName,
          }),
          "on": {
            change: ({
              detail
            }) => $helpers.handleClickAction(actionOption.eventName, detail.item),
          },
          "class": {
            'action': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'search-first': $attr(`search-first`)
        }, {
          'filter-bar': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`selected-count`) > 0 || $attr(`always-show-count`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `selectedCount`
            }),
            "on": {
              click: $helpers.handleClearSelected
            },
            "class": {
              'selected-count': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'results': true
              },
            }, [__vjadeSafeCode($helpers.getSelectedCountLabel())]));
            __jade_nodes = __jade_nodes.concat(($attr(`selected-count`) > 0) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'x-button-wrap': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: `x`
                  }),
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'action-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`actions`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, actionOption, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'action-container': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((actionOption.sections && actionOption.sections.length > 0) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['multiple-action'].call(this, {
                          actionOption
                        }));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['simple-action'].call(this, {
                          actionOption
                        }));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var actionOption = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'action-container': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((actionOption.sections && actionOption.sections.length > 0) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['multiple-action'].call(this, {
                              actionOption
                            }));;
                            return __jade_nodes
                          }).call(this)) : ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['simple-action'].call(this, {
                              actionOption
                            }));;
                            return __jade_nodes
                          }).call(this)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filtered-count': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `resultCount`
              }),
              "class": {
                'results': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + ($attr(`result-count`)) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              hidden: $helpers.isFilterSectionHidden()
            }, {
              'filter-by-text': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Filter by");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filter-options': true
            },
          }, (function() {
            var __jade_nodes = [];
            const maxWidth = `${Math.floor(100 / $attr(`filters`).length) - 5}%`;
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`filters`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, filterSelectConfig, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((((filterSelectConfig.filterType) == ($helpers.FilterType.UserProperties))) ?
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("filter-bar-user-properties-filter", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            name: filterSelectConfig.name,
                            label: $helpers.getFilterSelectedLabel(filterSelectConfig),
                            'project-id': filterSelectConfig.projectId,
                            'workspace-id': filterSelectConfig.workspaceId,
                            'single-data-group': filterSelectConfig.singleDataGroup,
                            selected: filterSelectConfig.selected,
                            'selector-icon': filterSelectConfig.selectorIcon,
                            'track-name': filterSelectConfig.trackName,
                          }),
                          "on": {
                            changeFilter: $helpers.handleFilterChanged,
                            applyFilter: $helpers.handleFilterApplyClicked,
                            menuChange: (ev) => {
                              $helpers.handleMenuChange(ev, filterSelectConfig.name)
                            },
                            selectAll: (ev) => {
                              $helpers.handleAllSelected(ev, filterSelectConfig.name)
                            }
                          },
                          "props": {
                            getSortedMenuSections: (sections) => getFilterSortedMenuSections ? getFilterSortedMenuSections(filterSelectConfig.name, sections) : sections
                          },
                          "style": {
                            'max-width': maxWidth,
                          },
                          "class": {
                            'filter-option': true,
                            [filterSelectConfig.name]: true,
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) :
                      (((filterSelectConfig.filterType) == ($helpers.FilterType.Complex))) ?
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("filter-bar-complex-filter", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            sections: filterSelectConfig.sections,
                          }),
                          "on": {
                            changeFilter: $helpers.handleFilterChanged,
                            menuChange: (ev) => {
                              $helpers.handleMenuChange(ev, filterSelectConfig.name)
                            },
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) :
                      ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("filter-bar-simple-filter", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            name: filterSelectConfig.name,
                            multiple: filterSelectConfig.multiple,
                            'apply-button': filterSelectConfig.applyButton,
                            label: $helpers.getFilterSelectedLabel(filterSelectConfig),
                            sections: filterSelectConfig.sections,
                            'no-filter-label': filterSelectConfig.noFilterLabel,
                            'menu-width': filterSelectConfig.menuWidth || 200,
                          }),
                          "on": {
                            changeFilter: $helpers.handleFilterChanged,
                            applyFilter: $helpers.handleFilterApplyClicked,
                            menuChange: (ev) => {
                              $helpers.handleMenuChange(ev, filterSelectConfig.name)
                            },
                          },
                          "style": {
                            'max-width': maxWidth,
                          },
                          "class": {
                            'filter-option': true,
                            [filterSelectConfig.name]: true,
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var filterSelectConfig = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((((filterSelectConfig.filterType) == ($helpers.FilterType.UserProperties))) ?
                          ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("filter-bar-user-properties-filter", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                name: filterSelectConfig.name,
                                label: $helpers.getFilterSelectedLabel(filterSelectConfig),
                                'project-id': filterSelectConfig.projectId,
                                'workspace-id': filterSelectConfig.workspaceId,
                                'single-data-group': filterSelectConfig.singleDataGroup,
                                selected: filterSelectConfig.selected,
                                'selector-icon': filterSelectConfig.selectorIcon,
                                'track-name': filterSelectConfig.trackName,
                              }),
                              "on": {
                                changeFilter: $helpers.handleFilterChanged,
                                applyFilter: $helpers.handleFilterApplyClicked,
                                menuChange: (ev) => {
                                  $helpers.handleMenuChange(ev, filterSelectConfig.name)
                                },
                                selectAll: (ev) => {
                                  $helpers.handleAllSelected(ev, filterSelectConfig.name)
                                }
                              },
                              "props": {
                                getSortedMenuSections: (sections) => getFilterSortedMenuSections ? getFilterSortedMenuSections(filterSelectConfig.name, sections) : sections
                              },
                              "style": {
                                'max-width': maxWidth,
                              },
                              "class": {
                                'filter-option': true,
                                [filterSelectConfig.name]: true,
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) :
                          (((filterSelectConfig.filterType) == ($helpers.FilterType.Complex))) ?
                          ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("filter-bar-complex-filter", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                sections: filterSelectConfig.sections,
                              }),
                              "on": {
                                changeFilter: $helpers.handleFilterChanged,
                                menuChange: (ev) => {
                                  $helpers.handleMenuChange(ev, filterSelectConfig.name)
                                },
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) :
                          ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("filter-bar-simple-filter", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                name: filterSelectConfig.name,
                                multiple: filterSelectConfig.multiple,
                                'apply-button': filterSelectConfig.applyButton,
                                label: $helpers.getFilterSelectedLabel(filterSelectConfig),
                                sections: filterSelectConfig.sections,
                                'no-filter-label': filterSelectConfig.noFilterLabel,
                                'menu-width': filterSelectConfig.menuWidth || 200,
                              }),
                              "on": {
                                changeFilter: $helpers.handleFilterChanged,
                                applyFilter: $helpers.handleFilterApplyClicked,
                                menuChange: (ev) => {
                                  $helpers.handleMenuChange(ev, filterSelectConfig.name)
                                },
                              },
                              "style": {
                                'max-width': maxWidth,
                              },
                              "class": {
                                'filter-option': true,
                                [filterSelectConfig.name]: true,
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!$attr('hide-reset-filters') && $helpers.isFilterSelected()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.handleFilterReset
              },
              "class": {
                'reset-filter-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Reset Filter");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!$attr('hide-search')) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: `search`,
                placeholder: $attr(`search-placeholder`),
                value: searchText,
                elref: `searchInput`,
              }),
              "props": {
                maxLength: 50,
                value: searchText,
              },
              "on": {
                input: $helpers.handleUpdateInput,
              },
              "class": {
                'search-input': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "getFilterSortedMenuSections" in locals ? locals.getFilterSortedMenuSections : typeof getFilterSortedMenuSections !== "undefined" ? getFilterSortedMenuSections : undefined, "searchText" in locals ? locals.searchText : typeof searchText !== "undefined" ? searchText : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;